import axios from 'axios';

async function getNascimentos(filters: ApiFiltersType, token: string | null) {
  try {
    const response = await axios({
      headers: {
        Authorization: token
      },
      method: 'get',
      url: `${process.env.REACT_APP_SERVICE_API}/rest/json/animais/nascimentos`,
      params: {
        ...filters,
      }
    });
    return response.data
  } catch (error) {
    window.top!.location.href = `${process.env.REACT_APP_BASE_MANEJO}/adm/login`
    console.error(error);
  }
}

export { getNascimentos };
